import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=492b1c19&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=492b1c19&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492b1c19')) {
      api.createRecord('492b1c19', component.options)
    } else {
      api.reload('492b1c19', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=492b1c19&", function () {
      api.rerender('492b1c19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/orderDetail.vue"
export default component.exports